/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Aroma_Sampling_ImplementersInputs */

const vi_aroma_sampling_implementers = /** @type {(inputs: Aroma_Sampling_ImplementersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Người thực hiện`)
};

/**

* @param {Aroma_Sampling_ImplementersInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const aroma_sampling_implementers = /** @type {((inputs?: Aroma_Sampling_ImplementersInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Aroma_Sampling_ImplementersInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_aroma_sampling_implementers(inputs)
});